<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <h3 class="font-medium">{{ title }}</h3>

      <p class="text-sm mt-2 text-content-400">
        Define la fecha, hora y, si aplica, el link de la reunión. Se notificará al cliente.
      </p>

      <form @submit.prevent="confirm" class="mt-4">
        <div class="flex flex-col w-full">
          <label for="scheduled_for">Fecha y hora de la cita</label>
          <input
            id="scheduled_for"
            type="datetime-local"
            v-model="form.scheduled_for"
            required
          />
          <validation-errors :errors="errorFor('scheduled_for')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="meet_url">Link de la reunión (Meet) (opcional)</label>
          <input
            id="meet_url"
            type="url"
            v-model="form.meet_url"
            placeholder="https://meet.google.com/..."
          />
          <validation-errors :errors="errorFor('meet_url')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="message">Mensaje para el cliente (opcional)</label>
          <textarea id="message" class="h-24" v-model="form.message"></textarea>
          <validation-errors :errors="errorFor('message')"></validation-errors>
        </div>

        <primary-button class="w-auto mt-4" :loading="loading" type="submit">
          {{ confirmLabel }}
        </primary-button>

        <button v-if="!loading" class="link mt-4 mx-auto w-full" @click.prevent="close">
          Cancelar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";

export default {
  name: "Schedule Appointment Modal",

  mixins: [validationErrors],

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Registrar cita",
    },
    confirmLabel: {
      type: String,
      default: "Guardar",
    },
    initialScheduledFor: {
      type: String,
      default: null,
    },
    initialMeetUrl: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      form: {
        scheduled_for: this.toDatetimeLocal(this.initialScheduledFor),
        meet_url: this.initialMeetUrl || "",
        message: "",
      },
    };
  },

  methods: {
    toDatetimeLocal(datetime) {
      if (!datetime) return "";
      const date = new Date(datetime);
      if (Number.isNaN(date.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },

    close() {
      this.$emit("close");
    },

    confirm() {
      this.errors = {};
      if (!this.form.scheduled_for) {
        this.errors["scheduled_for"] = ["Campo requerido"];
        return;
      }
      this.$emit("confirm", {
        scheduled_for: `${this.form.scheduled_for.replace("T", " ")}:00`,
        meet_url: this.form.meet_url || null,
        message: this.form.message || null,
      });
    },
  },
};
</script>
